import { Badge } from 'foundations-components/transitional/components/Badge';
import { getBadgeColorByMethodName } from '../../config/methods';
import { DuplicateIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import I18n from 'I18n';

/** The `UIGridItem` children. */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Endpoint = ({
  method,
  path,
  marginBlockEnd
}) => {
  let copiedValue = path;
  if (!path.match(/^http(s)?/)) {
    copiedValue = `https://api.hubapi.com${path}`;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexWrap: "nowrap",
    marginBlockEnd: marginBlockEnd,
    children: [/*#__PURE__*/_jsx(Badge, {
      marginBlockEnd: "100",
      use: getBadgeColorByMethodName(method),
      children: method
    }), /*#__PURE__*/_jsx(Text, {
      as: "code",
      wordBreak: "break-all",
      paddingInline: "300",
      children: path
    }), /*#__PURE__*/_jsx(CopyButton, {
      use: "transparent",
      tooltipPlacement: "right",
      value: copiedValue,
      responsive: false,
      hint: I18n.text('developer-docs-shared-components.tooltips.copyRequestUrl'),
      padding: "0",
      children: /*#__PURE__*/_jsx(DuplicateIcon, {
        size: "100",
        color: "icon-core-subtle"
      })
    })]
  });
};
export default Endpoint;